(ns practitest.frontend.integration-settings.auto-sync-filters.subs
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::state
  (fn [db _]
    (:auto-sync-filters db)))

(re-frame/reg-sub
  ::initialized?
  :<- [::state]
  (fn [state _]
    (contains? state :rows)))

(re-frame/reg-sub
  ::rows
  :<- [::state]
  (fn [state _]
    (:rows state [])))

(re-frame/reg-sub
  ::all-filters
  :<- [::state]
  (fn [state _]
    (:all-filters state [])))

(re-frame/reg-sub
  ::warnings
  :<- [::state]
  (fn [state _]
    (:warnings state [])))

(re-frame/reg-sub
  ::sync-interval
  :<- [::state]
  (fn [state _]
    (:sync-interval state "")))

(re-frame/reg-sub
  ::saving?
  :<- [::state]
  (fn [state _]
    (:saving? state false)))

(re-frame/reg-sub
  ::changes-made?
  :<- [::state]
  (fn [state _]
    (:changes-made? state false)))

(re-frame/reg-sub
  ::cancel-url
  :<- [::state]
  (fn [state _]
    (:cancel-url state "")))

(re-frame/reg-sub
  ::sub-tabs-props
  :<- [::state]
  (fn [state _]
    {:active            (:active-tab state "")
     :tabs              (:tabs state [])
     :bugtracker-label  (:bugtracker-label state "")
     :identifier        (:identifier state "")
     :extra-offset?     true}))
